"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }
  return ar;
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslationsService = exports.TranslationsService = void 0;
var TranslationsStorage_1 = require("./TranslationsStorage");
var TranslationsApi_1 = require("./TranslationsApi");
var callbacks_1 = require("./interfaces/callbacks");
var TranslationIntl_1 = require("./TranslationIntl");
var fetchStatus_1 = require("./constants/fetchStatus");
var timeZone_1 = require("./constants/timeZone");
var TranslationsService = function () {
  function TranslationsService(config) {
    var _a;
    if (config === void 0) {
      config = {};
    }
    this.config = {
      apiUrl: '',
      storageName: 'gr-translations',
      namespaceSeparator: '.',
      payloadTransformer: function payloadTransformer(response, data) {
        return response.body[data.locale];
      },
      requestHeaders: {
        Accept: 'application/json'
      },
      eTagHeaderName: 'translations-etag',
      queryTransformer: function queryTransformer(locale, spaces) {
        return {
          locale: locale,
          spaces: spaces.join(',')
        };
      },
      locale: 'en',
      defaultTimeZoneId: timeZone_1.DEFAULT_TIMEZONE_ID,
      useETag: true
    };
    this.fetchedSpaces = new Set();
    this.fetchedTranslations = {};
    this.callbacks = (_a = {}, _a[callbacks_1.EventType.INTL_CHANGE] = [], _a);
    this.setConfig(config);
  }
  TranslationsService.prototype.setConfig = function (config) {
    var prevConfig = this.config;
    this.config = __assign(__assign({}, prevConfig), config);
    var _a = this.config,
      storageName = _a.storageName,
      apiUrl = _a.apiUrl,
      requestHeaders = _a.requestHeaders,
      eTagHeaderName = _a.eTagHeaderName,
      queryTransformer = _a.queryTransformer,
      locale = _a.locale,
      defaultTimeZoneId = _a.defaultTimeZoneId,
      useETag = _a.useETag;
    if (!this.storage || prevConfig.storageName !== storageName) {
      this.storage = new TranslationsStorage_1.TranslationsStorage({
        name: storageName
      });
    }
    var apiConfigHasChange = prevConfig.apiUrl !== apiUrl || prevConfig.requestHeaders !== requestHeaders || prevConfig.eTagHeaderName !== eTagHeaderName || prevConfig.queryTransformer !== queryTransformer || prevConfig.useETag !== useETag;
    if (!this.api || apiConfigHasChange) {
      this.api = new TranslationsApi_1.TranslationsApi({
        url: apiUrl,
        defaultHeaders: requestHeaders,
        eTagHeaderName: eTagHeaderName,
        queryTransformer: queryTransformer,
        useETag: useETag
      });
    }
    if (prevConfig.locale !== locale) {
      this.fetchedSpaces.clear();
      this.fetchedTranslations = {};
    }
    if (!this.intl || prevConfig.locale !== locale || prevConfig.defaultTimeZoneId !== defaultTimeZoneId) {
      this.createIntl();
    }
  };
  TranslationsService.prototype.fetch = function (spaces) {
    return __awaiter(this, void 0, void 0, function () {
      var locale, spacesToFetch, requestData, _a, result, responsePayload, fetchedTranslations, translationEntries, exception_1, cachedSpaces;
      var _b, _c;
      var _this = this;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            locale = this.config.locale;
            spacesToFetch = spaces.filter(function (space) {
              return !_this.fetchedSpaces.has(space);
            });
            if (!this.config.apiUrl) {
              throw new Error('Empty config.apiUrl. To use fetch config.apiUrl is required. Define it first');
            }
            if (spacesToFetch.length === 0) {
              return [2];
            }
            _d.label = 1;
          case 1:
            _d.trys.push([1, 6,, 10]);
            _b = {
              locale: locale,
              spaces: spacesToFetch
            };
            if (!this.config.useETag) return [3, 3];
            return [4, (_c = this.storage).getEtag.apply(_c, __spread([locale], spacesToFetch))];
          case 2:
            _a = _d.sent();
            return [3, 4];
          case 3:
            _a = undefined;
            _d.label = 4;
          case 4:
            requestData = (_b.eTag = _a, _b);
            return [4, this.api.fetch(requestData)];
          case 5:
            result = _d.sent();
            responsePayload = this.config.payloadTransformer(result, requestData);
            fetchedTranslations = responsePayload ? this.splitTranslations(responsePayload) : {};
            translationEntries = Object.entries(fetchedTranslations);
            translationEntries.forEach(function (_a) {
              var _b = __read(_a, 2),
                space = _b[0],
                keys = _b[1];
              return _this.registerTranslations(space, keys);
            });
            Promise.all(translationEntries.map(function (_a) {
              var _b = __read(_a, 2),
                space = _b[0],
                keys = _b[1];
              return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_c) {
                  return [2, this.storeTranslations(space, keys)];
                });
              });
            }))["catch"](this.logError);
            return [3, 10];
          case 6:
            exception_1 = _d.sent();
            if (!(exception_1.status === fetchStatus_1.NOT_MODIFIED)) return [3, 8];
            return [4, this.getStoredSpaceTranslations(spacesToFetch)];
          case 7:
            cachedSpaces = _d.sent();
            Object.entries(cachedSpaces).forEach(function (_a) {
              var _b = __read(_a, 2),
                space = _b[0],
                keys = _b[1];
              return _this.registerTranslations(space, keys);
            });
            return [3, 9];
          case 8:
            throw exception_1;
          case 9:
            return [3, 10];
          case 10:
            this.createIntl();
            return [2];
        }
      });
    });
  };
  TranslationsService.prototype.setTranslations = function (keys) {
    var e_1, _a, e_2, _b;
    var keysBySpace = {};
    var separator = this.config.namespaceSeparator;
    try {
      for (var _c = __values(Object.entries(keys)), _d = _c.next(); !_d.done; _d = _c.next()) {
        var _e = __read(_d.value, 2),
          key = _e[0],
          value = _e[1];
        var _f = __read(key.split(separator)),
          space = _f[0],
          keyParts = _f.slice(1);
        if (!keysBySpace[space]) {
          keysBySpace[space] = {};
        }
        keysBySpace[space][__spread([space], keyParts).join(separator)] = value;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c["return"])) _a.call(_c);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    try {
      for (var _g = __values(Object.entries(keysBySpace)), _h = _g.next(); !_h.done; _h = _g.next()) {
        var _j = __read(_h.value, 2),
          space = _j[0],
          spaceKeys = _j[1];
        this.registerTranslations(space, spaceKeys);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_h && !_h.done && (_b = _g["return"])) _b.call(_g);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    this.createIntl();
  };
  TranslationsService.prototype.getStoredSpaceTranslations = function (spaces) {
    return __awaiter(this, void 0, void 0, function () {
      var _a;
      return __generator(this, function (_b) {
        return [2, (_a = this.storage).getSpaces.apply(_a, __spread([this.config.locale], spaces))];
      });
    });
  };
  TranslationsService.prototype.getTranslations = function () {
    return this.fetchedTranslations;
  };
  TranslationsService.prototype.getLocale = function () {
    return this.config.locale;
  };
  TranslationsService.prototype.on = function (eventType, callback) {
    this.callbacks[eventType].push(callback);
    return this;
  };
  TranslationsService.prototype.off = function (eventType, callback) {
    var index = this.callbacks[eventType].indexOf(callback);
    if (index !== -1) {
      this.callbacks[eventType].splice(index, 1);
    }
    return this;
  };
  TranslationsService.prototype.fire = function (eventType) {
    var _this = this;
    var callbacks = this.callbacks[eventType];
    switch (eventType) {
      case callbacks_1.EventType.INTL_CHANGE:
        callbacks.forEach(function (callback) {
          return callback(_this.intl);
        });
        break;
    }
    return this;
  };
  TranslationsService.prototype.getIntl = function () {
    return this.intl;
  };
  TranslationsService.prototype.registerTranslations = function (space, keys) {
    this.fetchedTranslations = Object.entries(keys).reduce(function (translations, _a) {
      var _b = __read(_a, 2),
        key = _b[0],
        value = _b[1];
      translations[key] = value.replace(/<\/?br\s*\/?\s*>/g, '{br}');
      return translations;
    }, this.fetchedTranslations);
    this.fetchedSpaces.add(space);
  };
  TranslationsService.prototype.storeTranslations = function (space, keys) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2, this.storage.setSpace(this.config.locale, space, keys)];
      });
    });
  };
  TranslationsService.prototype.createIntl = function () {
    var _a = this.config,
      locale = _a.locale,
      defaultTimeZoneId = _a.defaultTimeZoneId;
    this.intl = new TranslationIntl_1.TranslationIntl({
      locale: locale,
      defaultTimeZoneId: defaultTimeZoneId,
      messages: this.fetchedTranslations
    });
    this.fireIntlChangeCallbacks();
  };
  TranslationsService.prototype.fireIntlChangeCallbacks = function () {
    this.fire(callbacks_1.EventType.INTL_CHANGE);
  };
  TranslationsService.prototype.splitTranslations = function (keys) {
    var _this = this;
    if (keys === void 0) {
      keys = {};
    }
    var spaces = {};
    Object.entries(keys).forEach(function (_a) {
      var _b = __read(_a, 2),
        key = _b[0],
        value = _b[1];
      var space = key.split(_this.config.namespaceSeparator)[0];
      if (!spaces.hasOwnProperty(space)) {
        spaces[space] = {};
      }
      spaces[space][key] = value;
    });
    return spaces;
  };
  TranslationsService.prototype.logError = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (process.env.NODE_ENV === 'development') {
      console.warn.apply(console, __spread(args));
    }
  };
  return TranslationsService;
}();
exports.TranslationsService = TranslationsService;
exports.defaultTranslationsService = new TranslationsService();